/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'sysque-pdf-location',
  templateUrl: './sysque-pdf-location.component.html',
  styleUrl: './sysque-pdf-location.component.scss',
  standalone: false
})

export class SysquePdfLocationComponent {
  @Input() fileName: string;
  @Output() attachFileClicked: EventEmitter<string> = new EventEmitter<string>();
  @Output() openPdf: EventEmitter<void> = new EventEmitter<void>();
  public attachPdf: string = 'Attach PDF';

  public onAttachFileClicked(): void {
    this.attachFileClicked.emit();
  }

  public onOpenPdf(): void {
    this.openPdf.emit();
  }
}
